module.exports = __webpack_public_path__ + "static/media/project-social.85dfaf72.jpg";